import { isString, isObject, sample } from 'lodash';
import { ActionOnFieldHandler } from './ActionOnFieldHandler';
import { BeforeSubmitTestData } from '../event/BeforeSubmitTestEventHandler';
import { operationBuilder } from '../condition/ConditionOnFieldEvaluator';

const SetValueActionPropertiesSupported = {
  TYPE: "type",
  FROM: "from",
  DATA: "data",
  FIELDS: "fields",
  OPERATION: "operation",
  VALUES: "values"
} as const;

const SetValueType = {
  ASSIGN: "assign",
  COMPARE: "compare",
  RANDOM: "random"
} as const;

export class SetValueActionHandler extends ActionOnFieldHandler {
  constructor() {
    super('setValue');
  }

  handleAction(actionPolicy: any, data: BeforeSubmitTestData): Promise<void> {
    if (this.canHandleAction(actionPolicy)) {
      const action = this.getAction(actionPolicy);
      const keys = Object.keys(action);
      keys.forEach((key) => {
        if (isObject(action[key])) {
          const actionObject = action[key];
          switch (actionObject[SetValueActionPropertiesSupported.TYPE]) {
            case SetValueType.ASSIGN: {
              if (actionObject[SetValueActionPropertiesSupported.DATA]) {
                data[key] = actionObject[SetValueActionPropertiesSupported.DATA];
              }
              if (actionObject[SetValueActionPropertiesSupported.FROM]) {
                data[key] = data[actionObject[SetValueActionPropertiesSupported.FROM]];
              }
              break;
            }
            case SetValueType.COMPARE: {
              const fields = actionObject[SetValueActionPropertiesSupported.FIELDS];
              data[key] = operationBuilder[
                actionObject[SetValueActionPropertiesSupported.OPERATION]
              ](data[fields[0]], data[fields[1]]);
              break;
            }
            case SetValueType.RANDOM: {
              const values = actionObject[SetValueActionPropertiesSupported.VALUES];
              data[key] = sample(values);
            }
          }
        } else {
          data[key] = isString(action[key])
            ? this.placeholderBuilder(action, action[key], data)
            : action[key];
        }
      });
    }
    return Promise.resolve();
  }
}
